import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

// Components
import PageWrapper from 'components/common/Layout/PageWrapper';
import Script from 'next/script';

// Configs
import { appConfig } from 'configs';

// Enhancer
import WithAuth from 'enhancers/wrappers/withAuth';
import WithStyle from 'enhancers/wrappers/withStyle';

// Redux
import { wrapper } from '../redux/store';

// Style
import '../theme/main.css';
import 'react-toastify/dist/ReactToastify.css';

const App = ({ Component, ...rest }) => {
	const { store, props } = wrapper.useWrappedStore(rest);

	return (
		<>
			{appConfig.google_tag_manager_id && (
				<Script
					id="gtm-script"
					strategy="afterInteractive"
					dangerouslySetInnerHTML={{
					__html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${appConfig.google_tag_manager_id}');`,
					}}
				/>
			)}
			{appConfig.google_analytics_id && (
				<>
					<Script
						src={`https://www.googletagmanager.com/gtag/js?id=${appConfig.google_analytics_id}`}
						strategy="afterInteractive"
			  		/>
			 		<Script 
						id="analytics-script" 
						strategy="afterInteractive"
						dangerouslySetInnerHTML={{
							__html: `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${appConfig.google_analytics_id}');`,
						}}
					/>
				</>
			)}
			{appConfig.hotjar_id && (
				<Script 
					id="hotjar-script"
					strategy="afterInteractive"
					dangerouslySetInnerHTML={{
						__html:	`(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:${appConfig.hotjar_id},hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`
					}}
				/>
			)}

			<Provider store={store}>
				<WithStyle>
					<ToastContainer position="top-right" />
					<WithAuth>
						<PageWrapper {...props}>
							<Component {...props.pageProps} />
						</PageWrapper>
					</WithAuth>
				</WithStyle>
			</Provider>
		</>
	);
};

export default App;
